import React from "react";

import { MatchCardExpandButton } from "../../components/match_card_expand_button";
import { useMatchCardContext } from "../../match_card_context";
import { MatchCardScores } from "../match_card_scores";
import { MatchCardShortlistButton } from "../match_card_shortlist_button";
import css from "./match_card_header.module.scss";
import { MatchProfileInfo } from "./match_profile_info";
import { MatchStatusIcons } from "./match_status_icons";

export const MatchCardHeader = () => {
  const { isOpen, toggleIsOpen } = useMatchCardContext();

  return (
    <div className={css.header}>
      <div className={css.cardControls}>
        <MatchCardExpandButton isOpen={isOpen} onClick={() => toggleIsOpen()} />
      </div>
      <div className={css.matchStatus}>
        <MatchCardScores />
        <MatchStatusIcons />
      </div>
      <div className={css.matchProfile}>
        <MatchProfileInfo />
        <div className={css.matchProfileActions}>
          <MatchCardShortlistButton />
        </div>
      </div>
    </div>
  );
};
